var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.6665V6.6665",
    stroke: "#4A56DC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 2.6665V6.6665",
    stroke: "#4A56DC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 14.6665H20",
    stroke: "#4A56DC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 20H16",
    stroke: "#4A56DC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.3332H12C5.33333 29.3332 4 26.5865 4 21.0932V12.8665C4 6.59984 6.22667 4.91984 10.6667 4.6665H21.3333C25.7733 4.9065 28 6.59984 28 12.8665V21.3332",
    fill: "#B6C0F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.3332H12C5.33333 29.3332 4 26.5865 4 21.0932V12.8665C4 6.59984 6.22667 4.91984 10.6667 4.6665H21.3333C25.7733 4.9065 28 6.59984 28 12.8665V21.3332",
    stroke: "#4A56DC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28 21.3335L20 29.3335V25.3335C20 22.6668 21.3333 21.3335 24 21.3335H28Z",
    fill: "#B6C0F3",
    stroke: "#4A56DC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.e84fecf8e5ad0c4d1ac31b7a06b585f3.svg";
export { ForwardRef as ReactComponent };